import React, { createContext } from "react";

const WalletContext = createContext();

export default WalletContext;
